import { useMemo, useEffect } from 'react';
import { useData } from '@/contexts/DataContext';
import { usePermissions } from '@/hooks/usePermissions';
import { useNewBadge } from '@/hooks/useNewBadge';
import GlobalFilters from '@/components/GlobalFilters';
import UploadSection from '@/components/UploadSection';
import PracticeForm from '@/components/PracticeForm';
import PracticeTable from '@/components/PracticeTable';
import { Loader2 } from 'lucide-react';

export default function DataPage() {
  const { getFilteredPractices, loading, deletePractice } = useData();
  const perms = usePermissions();
  const { previousLastSeen, clearPreviousLastSeen } = useNewBadge();
  // Reset evidenziazione quando si esce dalla pagina
  useEffect(() => {
    return () => clearPreviousLastSeen();
  }, [clearPreviousLastSeen]);

  const filtered = useMemo(() => getFilteredPractices(), [getFilteredPractices]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20" data-testid="data-loading">
        <Loader2 className="w-8 h-8 text-fw-yellow animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="data-page">
      <div className="rounded-lg p-[3px]" style={{background: 'linear-gradient(to right, #FDC400, #E60000)'}}>
        <div className="bg-fw-dark rounded-[5px] px-6 py-5">
          <h1 className="font-heading text-3xl font-bold text-white">Attività</h1>
          <p className="text-fw-subtle mt-1">Gestisci, carica e filtra le attività</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {perms.canCreatePractice && <PracticeForm />}
        {perms.canUploadExcel && <UploadSection />}
      </div>

      <GlobalFilters showSearch />

      <PracticeTable practices={filtered} onDelete={deletePractice} permissions={perms} entryLastSeen={previousLastSeen} />
    </div>
  );
}
